import React from "react";
import { TOOLTIP_THEMES } from "./constants";
import Popover from "../Popover";
import "./Tooltip.css";
import withTheme from "../../hocs/withTheme";

/** A basic widget for getting the user input is a text field.
 * Keyboard and mouse can be used for providing or changing data. */

function Tooltip(props) {
    const {
        title = null,
        theme = null,
        overlayClassName = "",
        children = null,
        ...rest
    } = props;

    return title ? (
        <Popover
            {...rest}
            title={title}
            className="rc-tooltiped-text"
            overlayClassName={`Tooltip ${
                theme ? `rc-tooltip-${theme}` : ""
            } ${overlayClassName}`}
        >
            {children}
        </Popover>
    ) : (
        children
    );
}


export default withTheme(Tooltip);
